// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import RationCardDetailsActionType from './ration-card-details.types';

const INITIAL_STATE = {
	// Update Ration card Response
	updateRationCardResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** Ration Card Details Update Start ************************/
		case RationCardDetailsActionType.UPDATE_RATION_CARD_SUCCESS:
			return { ...state, updateRationCardResponse: action.payload };

		case RationCardDetailsActionType.UPDATE_RATION_CARD_FAILURE:
			return { ...state, updateRationCardResponse: action.payload };

		case RationCardDetailsActionType.UPDATE_RATION_CARD_RESPONSE_CHANGED:
			return { ...state, updateRationCardResponse: null };
        /** ***************** Ration Card Details Update End ************************/
		default:
			return state;
	}
};
